import type { CodeProps as MantineCodeProps } from '@mantine/core';
import { Code as MantineCode } from '@mantine/core';

import type { LockedProps } from '../types';

type CodeProps = Omit<MantineCodeProps, LockedProps>;

export const Code = (props: CodeProps) => {
  return <MantineCode {...props} />;
};
